import axios from '@/utils/axios'
import qs from 'qs'

const base_server = ""
let static_server = ""
// 从location获取项目地址，拼接为api地址
let prefix = location.pathname.split("/").slice(0, 2).join("/") + "/api"
if(process.env.NODE_ENV=='development') {
    prefix = "/data/api/"
    // prefix = "/data-wyWtGVY43xYd/api/"
    static_server = "/data"
}
//let prefix = ""

// if(process.env.NODE_ENV=='development') {
//     prefix = ""
// }

const locationSearch = qs.parse(location.search.length>0?location.search.substring(1):"")
const PROJ_CODE = locationSearch.proj
const LANG = locationSearch.lang
const PAGE_NAME = location.hash.length>1?location.hash.substring(2):""

const login_url = "login.html"
const logout_url = `${prefix}/openid/logout/`
const user_info_url = `${prefix}/openid/user_info/`
let api = {
    common: {
        project: `${prefix}/common/projects/`,
        log: `${prefix}/common/log/`,
        alert: `${prefix}/common/alert/`,
        allproject: `${prefix}/common/allprojects/`,
        authrequest: `${prefix}/common/auth_requests/`,
        user_search: `${prefix}/common/user_search/`
    },
    home: {
        project: `${prefix}/home/projects/`,
        overview: `${prefix}/home/overview/`,
        chart: `${prefix}/home/chart/`,
        option: `${prefix}/home/options/`,
    },
    project: {
        total_info: `${prefix}/project/${PROJ_CODE}/total_info/`,
        info: `${prefix}/project/${PROJ_CODE}/info/`,
        module: `${prefix}/project/${PROJ_CODE}/modules/`,
        menu: `${prefix}/project/${PROJ_CODE}/menus/`,
        custom_menu: `${prefix}/project/${PROJ_CODE}/custom_menu/`,
        custom_submenu: `${prefix}/project/${PROJ_CODE}/custom_submenu/`,
        visit: `${prefix}/project/${PROJ_CODE}/visits/`,
        time_stat: `${prefix}/project/${PROJ_CODE}/time_stats/`,
        server: `${prefix}/project/${PROJ_CODE}/servers/`,
        config: `${prefix}/project/${PROJ_CODE}/configs/`,
        page_visit: `${prefix}/project/${PROJ_CODE}/page_visits/`,
        query: `${prefix}/project/${PROJ_CODE}/query/`,
        query_fixed_module: `${prefix}/project/${PROJ_CODE}/query_fixed_module/`,
        mark: `${prefix}/project/${PROJ_CODE}/marks/`,
        remark: `${prefix}/project/${PROJ_CODE}/`
    },
    manage: {
        project: `${prefix}/manage/projects/`,
        alluser: `${prefix}/manage/users/`,
        upload_file: `${prefix}/manage/upload_file/`,
        module: `${prefix}/manage/${PROJ_CODE}/modules/`,
        submodule: `${prefix}/manage/${PROJ_CODE}/submodules/`,
        group: `${prefix}/manage/${PROJ_CODE}/groups/`,
        user: `${prefix}/manage/${PROJ_CODE}/users/`,
        staff: `${prefix}/manage/${PROJ_CODE}/staffs/`,
        version_day: `${prefix}/manage/${PROJ_CODE}/version_days/`,
        mark: `${prefix}/manage/${PROJ_CODE}/marks/`,
        searcher: `${prefix}/manage/${PROJ_CODE}/searchers/`,
        consume: `${prefix}/manage/${PROJ_CODE}/consumes/`,
        table: `${prefix}/manage/table/`,
        cache: `${prefix}/manage/${PROJ_CODE}/caches/`,
        dim: `${prefix}/manage/${PROJ_CODE}/dims/`,
        fashion: `${prefix}/manage/${PROJ_CODE}/fashion/`,
        reportmail: `${prefix}/manage/${PROJ_CODE}/report/`,
        info: `${prefix}/manage/${PROJ_CODE}/info/`,
        standard: `${prefix}/manage/${PROJ_CODE}/standards/`,
        gstandard: `${prefix}/manage/gstandards/`,
    },
    tool: {
        aduser: {
            permission: `${prefix}/tool/aduser/permissions/`,
            tag: `${prefix}/tool/aduser/tags/`,
            rank: `${prefix}/tool/aduser/ranks/`,
            transfer: `${prefix}/tool/aduser/transfers/`,
        },
        tap: {
            data: `${prefix}/tool/tap/datas/`,
            permission: `${prefix}/tool/tap/permissions/`,
        },
        apprank: {
            rank: `${prefix}/tool/apprank/rank/`,
            permission: `${prefix}/tool/apprank/permissions/`,
            product: `${prefix}/tool/apprank/products/`,
            productPermission: `${prefix}/tool/apprank/productPermissions/`,
            app: `${prefix}/tool/apprank/app/`,
            effect: `${prefix}/tool/apprank/effect/`,
        },
        path: {
            data: `${prefix}/tool/path/datas/`,
            permission: `${prefix}/tool/path/permissions/`,
        },
        alarm: {
            game: `${prefix}/tool/alarm/game/`,
            whitelist: `${prefix}/tool/alarm/${PROJ_CODE}/whitelist/`,
            alarm: `${prefix}/tool/alarm/${PROJ_CODE}/alarm/`,
            permission: `${prefix}/tool/alarm/${PROJ_CODE}/permissions/`,
            dim: `${prefix}/tool/alarm/${PROJ_CODE}/dim/`,
            download: `${prefix}/tool/alarm/${PROJ_CODE}/download/`,
        }
    }
}

export default {
    PROJ_CODE,
    LANG,
    PAGE_NAME,
    base_server: base_server,
    static_server: static_server,
    prefix: prefix,
    api: api,
    login: () => login(),
    logout: () => logout(),
    userInfo:() => userInfo(),
    log:(type, page, params, duration, error) => log(type, page, params, duration, error),
    query:(id, params) => query(id, params),
    queryDownload:(id, params, self) => queryDownload(id, params, self),
    query_fixed_module:(id, params) => query_fixed_module(id, params),
    getData:(api, params) => getData(api, params),
    addData:(api, params) => addData(api, params),
    updateData:(api, params) => updateData(api, params),
    patchData:(api, params) => patchData(api, params),
    deleteData:(api, params) => deleteData(api, params),
    uploadData:(api, params, put) => uploadData(api, params, put),
    downloadData:(api, params) => downloadData(api, params),
}

const login = () => {
    window.location.href = login_url
}

const logout = async () => {
    // store.commit('clear_user')
    axios.post(`${base_server}${logout_url}`).then(()=>{
        window.location.href = login_url
    }).catch(()=>{
        window.location.href = login_url
    })
}

const userInfo = () => {
    return axios.get(`${base_server}${user_info_url}`)
}

// 日志
const log = (type, page, sub, params, duration, error) => {
    let project = PROJ_CODE?PROJ_CODE:''
    return axios.post(`${base_server}${api.common.log}`,  {type, project, page, sub, params, duration, error})
}

// 查询通用页面
const query = (id, params) => {
    return axios.post(`${base_server}${api.project.query}${id}/`,  {search:params}, true)
}

// 查询下载页面
const queryDownload = (id, params, self) => {
    let url = `${base_server}${api.project.query}`
    axios.download(url, id, params, self)
    // const download = `${id}_${Date.now()}`
    // const iframe = document.createElement('iframe')
    // iframe.className = 'iiframe'
    // iframe.src = `${base_server}${api.project.query}${id}/?download=${download}&search=${JSON.stringify(params)}`
    // document.body.appendChild(iframe)
  
    // let checker
    // const cancel = () => {
    //     clearInterval(checker)
    //     document.body.removeChild(iframe)
    //     self.loading = false
    // }
  
    // checker = setInterval(() => {
    //   try {
    //     if (iframe.contentWindow.document.cookie.indexOf(download) > -1) {
    //         cancel()
    //     }
    //   } catch (e) {
    //     cancel()
    //   }
    // }, 100)
  }
  

// 查询固定模块页面
const query_fixed_module = (id, params) => {
    // qs会把undefined参数去掉，所以需要置为null
    if(params){
        Object.keys(params).forEach((k,index)=>{
            if(params[k] == undefined)
                params[k] = null
        })
    }
    return axios.post(`${base_server}${api.project.query_fixed_module}${id}/`,  params)
}

const getData = (api, params) => {
    // qs会把undefined参数去掉，所以需要置为null
    if(params){
        Object.keys(params).forEach((k,index)=>{
            if(params[k] == undefined)
                params[k] = null
        })
    }
    return axios.get(base_server + api,  params)
}

const addData = (api, params) => {
    // qs会把undefined参数去掉，所以需要置为null
    if(params){
        Object.keys(params).forEach((k,index)=>{
            if(params[k] == undefined)
                params[k] = null
        })
    }
    return axios.post(base_server + api,  params)
}

const updateData = (api, params) => {
    // qs会把undefined参数去掉，所以需要置为null
    if(params){
        Object.keys(params).forEach((k,index)=>{
            if(params[k] == undefined)
                params[k] = null
        })
    }
    return axios.put(base_server + api,  params)
}

const patchData = (api, params) => {
    // qs会把undefined参数去掉，所以需要置为null
    if(params){
        Object.keys(params).forEach((k,index)=>{
            if(params[k] == undefined)
                params[k] = null
        })
    }
    return axios.patch(base_server + api,  params)
}

const deleteData = (api, params) => {
    if(params){
        Object.keys(params).forEach((k,index)=>{
            if(params[k] == undefined)
                params[k] = null
        })
    }
    return axios.delete(base_server + api,  params)
}

const uploadData = (api, params, put) => {
    // qs会把undefined参数去掉，所以需要置为null
    if(params){
        Object.keys(params).forEach((k,index)=>{
            if(params[k] == undefined)
                params[k] = null
        })
    }
    return axios.upload(base_server + api,  params, put)
}

// 查询下载页面
const downloadData = (api, params) => {
    let url = base_server + api
    if(params){
        let query = []
        Object.keys(params).forEach((k,index)=>{
            if(params[k] != null) {
                query.push(`${k}=${params[k]}`)
            }
        })
        if(query.length > 0) {
            url = `${url}?${query.join('&')}`
        }
    }
    window.open(url,'_blank');
}